import React from "react";

class FullScreenOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.getRootStyle = this.getRootStyle.bind(this);
  }
  // eslint-disable-next-line
  getRootStyle(show) {
    const { axis, startingPosition } = this.props;
    const isPositive = startingPosition === "positive" ? "" : "-";
    return {
      background: "white",
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
      position: "absolute",
      overflow: "hidden",
      pointerEvents: show ? "auto" : "none",
      willChange: "transform, opacity",
      transition: show
        ? "opacity 200ms linear, transform 300ms linear"
        : "opacity 200ms linear, transform 200ms linear",
      transform: show
        ? "none"
        : `translate${axis.toUpperCase()}(${isPositive}102%)`,
      opacity: show ? 1 : 0,
      // TODO: remove zIndex after fixing arrow svg
      zIndex: 10
    };
  }
  // eslint-disable-next-line
  getOverlayStyle(show) {
    return {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      opacity: show ? 1 : 0,
      pointerEvents: "none",
      background: "rgba(0,0,0,0.5)",
      transition: show
        ? "opacity 0.2s cubic-bezier(0,0, 0.3, 1)"
        : "opacity 0.0s linear",
      willChange: "opacity",
      zIndex: 9
    };
  }

  render() {
    return (
      <React.Fragment>
        <div style={this.getOverlayStyle(this.props.show)} />
        <div style={this.getRootStyle(this.props.show)}>
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}

export default FullScreenOverlay;



// WEBPACK FOOTER //
// ./src/FullScreenOverlay/FullScreenOverlay.js